import {getFilesDataFromMediaCollection} from "../../helpers/media-library/collections";
import Axios from "axios";
import {loading, stopLoading} from "../../helpers/loading";
import handleAjaxError from "../../helpers/handleAjaxError";
import {createSpreadsheetGrid} from "../../helpers/grids/custom/spreadsheets/spreadsheetGrid";
import {handleAjaxSuccess} from "../../helpers/swalHelper";

function initBulkOrderImportIndex() {
	// noinspection JSUnresolvedVariable
	const livewire = window.Livewire;

	// We want to hook into spate media uploader, we need to
	// first hook into livewire
	livewire.hook('message.processed', component => {
		// Something was updated using livewire
		const element = component.component.el;
		if (element && element.classList.contains('media-library-filled')) {
			// A file was uploaded and rendered

			// Remove delete link as we don't care about it
			const removeLink = element.querySelector('.media-library-text-link[dusk="remove"]');
			// Remove text
			removeLink.innerHTML = '';
			// Make unusable
			removeLink.disabled = true;

			// Retrieve UUID of uploaded file so we can use it
			const files = getFilesDataFromMediaCollection(document.body, 'file');
			const fileUUID = Object.values(files)[0].uuid;

			processFile(fileUUID)
		}
	})

	const fileDataContainer = document.querySelector('.file-data-container');
	const importOrdersButton = document.querySelector('.import-orders-button');

	importOrdersButton.addEventListener('click', importOrders)

	/** @type {GridInstance|null} */
	let fileGrid = null;

	// Methods

	function processFile(fileUUID) {
		loading();

		// Clear file data container
		fileDataContainer.innerHTML = '';
		// Delete existing grid
		if (fileGrid) {
			fileGrid.api.destroy();
		}
		// Disable final button
		importOrdersButton.disabled = true;

		Axios.post(window['routes/client.voe-orders.import.process-file'].replace('__FILE__', fileUUID))
			.then(response => {
				const {ordersCount, rowErrors, fileMetaData} = response.data;

				let errorsHtml = '';

				// Display soft errors
				if (rowErrors) {
					errorsHtml += '<div class="text-danger font-weight-bold border-bottom">File Has Errors</div>';
					errorsHtml += '<div class="errors px-2" style="max-height: 200px; overflow: auto">';

					Object.values(rowErrors).forEach(rowError => {
						errorsHtml += `<div>Line #${rowError.index + 1}: ${rowError.error}</div>`;
					})

					errorsHtml += '</div>';
				} else {
					// Enable final button
					importOrdersButton.disabled = false;
				}

				fileDataContainer.innerHTML = `
					<div>
						<span class="mono-font">ORDERS FOUND: </span> ${ordersCount}
						${errorsHtml}
					</div>
				`;

				// Init new grid
				// noinspection JSUnresolvedVariable
				const getGridRowsUrl = window['routes/client.voe-orders.import.preview-file-grid'].replace('__FILE__', fileUUID);

				fileGrid = createSpreadsheetGrid(
					document.querySelector('.file-grid'),
					fileMetaData,
					getGridRowsUrl,
					{
						withColumnSelects: false,
						customGetRowClass: params => {
							const classes = [];

							if (params && params.data) {
								if (params.data.index === 0) {
									// Ignore first row
									classes.push('ignored');
								}
								// Check if row has errors
								if (rowErrors && rowErrors[params.data.index]) {
									classes.push('red-error-background');
								}
							}

							return classes;
						}
					},
					{
						_rowName: 'rows'
					}
				)
			})
			.catch(handleAjaxError)
			.finally(stopLoading)
	}

	/**
	 * Final step, import orders
	 */
	function importOrders() {
		// Just in case, check if button is disabled
		if (importOrdersButton.disabled) {
			return;
		}

		// Retrieve UUID of uploaded file so we can use it
		const files = getFilesDataFromMediaCollection(document.body, 'file');
		const fileUUID = Object.values(files)[0].uuid;

		loading();

		Axios.post(window['routes/client.voe-orders.import.import-orders'].replace('__FILE__', fileUUID))
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading)
	}
}

export {initBulkOrderImportIndex}
